import { render, staticRenderFns } from "./dob_picker.vue?vue&type=template&id=1bdb8114&"
import script from "./dob_picker.vue?vue&type=script&lang=js&"
export * from "./dob_picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports